import AutoTypeIcon from '@components/icons/CargoTypeIcons/AutoTypeIcon';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { TransportCountByType } from '@services/requests/routeCalculator/cargoConverterService/SelectCargoParametersQuery';
import clsx from 'clsx';
import React from 'react';

import { getShortCargoForTruck } from '../helpers';

interface ShortResultTruckProps {
  truckParameter: TransportCountByType;
  BaseData: RouteWidgetBaseParameters;
  mainLanguage: string;
}

function ShortResultTruck({ truckParameter, BaseData, mainLanguage }: ShortResultTruckProps) {
  const truckCargoDescription = getShortCargoForTruck(
    BaseData.trucks,
    truckParameter,
    mainLanguage
  );

  return (
    <div className="selection-result-item">
      <div className={clsx('selection-result-item__cargo')}>
        <div className="selection-result-item__icon">
          <AutoTypeIcon />
        </div>
        <span className="selection-result-item__title">{truckCargoDescription}</span>
      </div>
    </div>
  );
}

export { ShortResultTruck };
